import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { MCPConfigSnippet } from '../../../../src/components/Product/MCP/MCPConfig';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ol>
      <li parentName="ol">{`Open `}<a parentName="li" {...{
          "href": "https://zed.dev"
        }}>{`Zed`}</a>{` and update `}<inlineCode parentName="li">{`settings.json`}</inlineCode>{` with the following configuration:`}</li>
    </ol>
    <MCPConfigSnippet variant="zed" mdxType="MCPConfigSnippet" />
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol"><strong parentName="li">{`Save`}</strong>{` the configuration file`}</li>
      <li parentName="ol">{`The PostHog MCP server will be available`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      